import CarrierStatus from "./carrier-status.component";

export default CarrierStatus;
